import { useEffect } from 'react';
import './App.css';
import AuthorPage from './components/author-page/AuthorPage';
import ChhattisgarhNews from './components/chhattisgarh/ChhattisgarhNews';
// import Entertainment from './components/entertainment/Entertainment';
// import MadhyaPradeshNews from './components/madhyapradesh/MadhyaPradeshNews';
import NewsDetails from './components/news-details/NewsDetails';
import Header from './pages/header/Header';
import Home from './pages/home/Home';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Footer from './pages/footer/Footer';
import ChhattisgarhPage from './components/news-details/ChhattisgarhPage';
import AboutUs from './components/about-us/AboutUs';

// ----------------- GOOGLE ANALYTICS ROUTE TRACKER -----------------
const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-2GSKSW52FZ', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  return null;
};


function App() {
  
  return (
    <BrowserRouter>
     <AnalyticsTracker />
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/category/:slug" element={<ChhattisgarhNews />} />
        <Route path="/search" element={<ChhattisgarhNews />} />
          <Route path="/chhattisgarh" element={<ChhattisgarhPage />} />
        <Route path="/:slug" element={<NewsDetails />}/>
        <Route path="/author/:id" element={<AuthorPage />}/>
        {/* Other category routes are now handled by /category/:slug */}
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
